import React, { useCallback, useMemo, useState } from 'react';
import { Box, Checkbox, Dropdown, Option, OptionKey, Text } from '@common-fe/common-fe';

interface Props {
  isLoading?: boolean;
  values: OptionKey[];
  options: Option[];
  onChangeValues: (values: OptionKey[]) => void;
}
const TransactionsStatusSelect: React.FC<Props> = ({ values, onChangeValues, isLoading, options }) => {
  const [isExpanded, setExpanded] = useState(false);

  const currentTitle = useMemo(() => {
    if (values.length) {
      return values.map((value) => options.find((option) => option.key === value)?.title).join(', ');
    }
    return 'All';
  }, [options, values]);
  const handleToggleValue = useCallback(
    (key: string) => {
      let list = [...values];
      if (list.includes(key)) {
        list = list.filter((item) => item !== key);
      } else {
        list = [...list, key];
      }
      onChangeValues(list);
    },
    [onChangeValues, values]
  );
  const disabledApplied = useMemo(() => isLoading || options.length === 0, [isLoading, options.length]);
  return (
    <Box width="240px" data-testid="transaction_funds_select">
      <Dropdown
        placeholder="Placeholder"
        isClickOutside={true}
        testId="transaction_funds_select"
        prefix="Fund"
        disabled={disabledApplied}
        expanded={isExpanded}
        title={
          <Text title={currentTitle} color={disabledApplied ? 'textDisabled' : 'textAccent'} truncate>
            {currentTitle}
          </Text>
        }
        onSetExpanded={setExpanded}
      >
        <Box direction="column" data-testid="" pad="s" height={{ max: '360px' }} style={{ overflow: 'auto' }}>
          {options.map((item) => (
            <div key={item.key}>
              <Box pad={{ horizontal: 'xs', vertical: 'xxs' }}>
                <Checkbox
                  name={`${item.key}`}
                  testId="transaction_funds_select"
                  checked={values.includes(item.key)}
                  onChange={() => handleToggleValue(item.key as string)}
                >
                  <Text>{item.title}</Text>
                </Checkbox>
              </Box>
            </div>
          ))}
        </Box>
      </Dropdown>
    </Box>
  );
};

export default TransactionsStatusSelect;
